import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Sidebar from "../components/sidebar";
import Notification from "../components/Notification";
import ProfileDropdown from "../components/ProfileDropdown";
import "../styles/Profile.css";
import "../styles/Dashboard.css";

const Profile = () => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  // Ambil username & token dari localStorage
  const username = localStorage.getItem("username");
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (!username || !token) {
      console.warn("🚨 Tidak ada username atau token. Redirect ke login.");
      navigate("/login", { replace: true });
      return;
    }

    const fetchProfile = async () => {
      try {
        console.log(`🔍 Fetching profile for: ${username}`);

        const res = await axios.get(`https://depotaircerdas.com/api/profile/${username}`, {
          headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
          }
        });

        console.log("✅ Response:", res.data);
        setProfile(res.data);
      } catch (err) {
        console.error("❌ Error fetching profile:", err);
        setError("Gagal mengambil data profil. Periksa koneksi atau token.");
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, [username, token, navigate]);

  const handleLogout = () => {
    localStorage.removeItem("username");
    localStorage.removeItem("token"); // Hapus token juga
    navigate("/login");
  };

  return (
    <div className="profile-container">
      {/* Header dengan Notifikasi & Profil */}
      <div className="dashboard-header">
        <h2 className="header-title">👤 Profil Pengguna</h2>
        <div className="header-right">
          <Notification />
          <ProfileDropdown username={username} />
        </div>
      </div>

      <Sidebar />

      <div className="profile-content">
        {loading ? (
          <div className="spinner"></div>
        ) : error ? (
          <p className="error">{error}</p>
        ) : profile ? (
          <div className="profile-card fade-in">
            <p><strong>👤 Username:</strong> {profile.username}</p>
            <p><strong>🏢 Depot Name:</strong> {profile.depot_name || "Tidak Tersedia"}</p>
            <p><strong>📍 Address:</strong> {profile.address || "Tidak Tersedia"}</p>
            <button className="logout-btn" onClick={handleLogout}>Logout 🚪</button>
          </div>
        ) : (
          <p className="error">Data profil tidak tersedia.</p>
        )}
      </div>
    </div>
  );
};

export default Profile;
